import { type PetitionDetailsPageData, usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';
import { usePetitionDetailsPageUserData } from 'src/app/pages/petitionDetails/pageContext';

import { useShareVisualContents } from '../useShareVisualContents';

type Context = 'petition_page';
type UseShareVisualReturn = ModelHookResult<
	{
		buttonDisabled: boolean;
		shareVisualDownloaded: boolean;
		shareVisualEnabled: boolean;
		shareVisualsState: 'loading' | 'loaded' | 'timeout';
		petition: PetitionDetailsPageData['petition'];
	},
	{
		onShareVisualDownload: (event: React.FormEvent<HTMLFormElement>) => void;
		onShareVisualSelect: () => void;
	}
>;

export function useShareVisual(): UseShareVisualReturn {
	const {
		data: { petition },
	} = usePetitionDetailsPageData();
	const {
		data: { shareVisualsExperimentEnabled },
	} = usePetitionDetailsPageUserData();
	const context: Context = 'petition_page';
	const {
		data,
		actions: { onShareVisualDownload, onShareVisualSelect },
	} = useShareVisualContents({ petition, context });

	return {
		data: {
			petition,
			buttonDisabled: data.disabled,
			shareVisualDownloaded: data.shareVisualDownloaded,
			shareVisualEnabled: shareVisualsExperimentEnabled,
			shareVisualsState: data.shareVisualsState,
		},
		actions: {
			onShareVisualDownload,
			onShareVisualSelect,
		},
	};
}
